import { AUTH_LOADING, AUTH_END_LOADING, AUTH_GET_DATA } from "../redux/types";
import { removeToken } from "./axiosFunctions";
import { redirect } from "../utils/domUtils";
import * as api from "./api";

/**
 * Elimina la sesion del usuario y redirecciona a inicio
 */
export const logingOut = () => {
  removeToken();
  redirect("/");
};

/**
 * Autentifica a un usuario y lo redirige al dashboard
 */
export const authUser =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/users/login",
      data,
      loadingType: AUTH_LOADING,
      successType: AUTH_GET_DATA,
      errorType: AUTH_END_LOADING,
      delay: 500,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

/**
 * Registra a un nuevo usuario y lo redirige al dashboard
 */
export const registerUser =
  (data, callbackFN = null) =>
  async (dispatch) => {
    const response = await api.post(dispatch, {
      url: "/users/register",
      data,
      loadingType: AUTH_LOADING,
      successType: AUTH_GET_DATA,
      errorType: AUTH_END_LOADING,
    });
    if (callbackFN) callbackFN(response?.success || false);
  };

export const getSetDataPayload = (user) => {
  return {
    type: AUTH_GET_DATA,
    payload: user,
  };
};
